import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';
import { useRecoilState } from 'recoil';

import { updateUserPreferences } from 'api/Preferences';

import { current_admin } from 'components/admin/lib/adminState';

const useEditUserPreferences = (key) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [adminState, setAdminState] = useRecoilState(current_admin);

  const editUserPreferences = async (value) => {
    setAdminState({
      ...adminState,
      preferences: { ...adminState.preferences, [key]: value }
    });
    const res = await updateUserPreferences(navigate, {
      name: key,
      value
    });

    if (res?.code === 0) {
      queryClient.setQueryData(['preferences', key], (oldData) => {
        const newPreferences = res?.preferences;
        return {
          ...oldData,
          preferences: { ...oldData?.preferences, value: newPreferences }
        };
      });
    }
  };

  return { adminState, editUserPreferences };
};

export default useEditUserPreferences;
